<script lang="ts" setup>
const client = useBoscaClient()
const movement = await client.content.getItems('movement', 0, 3)

defineProps<{
  toggleOpen: () => void
}>()
</script>

<template>
  <div>
    <div class="meta-info mb-2">
      {{ $t('aroundTheMovement') }}
    </div>
    <ul>
      <li
        v-for="location in movement.items"
        :key="location.slug"
        class="h3 text-gray-500 hover:text-black"
      >
        <PLink
          :id="'around-the-movement-' + location.slug"
          :to="'/collections/' + location.slug"
          :click="toggleOpen"
        >
          {{ location.name }}
        </PLink>
      </li>
    </ul>
  </div>
</template>
